import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
} from '@angular/router';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable()
export class RouteGuard implements CanActivate {
  isRouteAllowed: boolean;
  constructor(
    private router: Router,
    private activated: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.isRouteAllowed = false;
  }

  canActivate(
    next: ActivatedRouteSnapshot,

    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.isRouteAllowed = false;
    var self = this;
    
    // Get user data from localStorage
    let user = null;
    try {
      user = JSON.parse(localStorage.getItem('user'));
    } catch (e) {
      console.error('Error parsing user from localStorage:', e);
    }

    // Check if user is SuperAdmin - allow all routes
    if (user && user.Roles && Array.isArray(user.Roles)) {
      const isSuperAdmin = user.Roles.some(role => 
        role.RoleName && 
        (role.RoleName.toLowerCase() === 'guestsuperadmin' || 
         role.RoleName.toLowerCase() === 'guest super admin')
      );

      if (isSuperAdmin) {
        console.log('SuperAdmin detected - bypassing route guard, allowing access to:', next.routeConfig.path);
        return true;
      }
    }

    // Regular resource-based check for non-SuperAdmin users
    let resourcesValue = JSON.parse(localStorage.getItem('resources'));

    var nextPath = next.routeConfig.path;

    if (nextPath === 'dashboards/director-view') {
      const canAccessDirectorView = _.some(resourcesValue, function (data) {
        const menu = (data.Menu || '').toLowerCase();
        return (
          menu === 'meetings' ||
          menu === 'dashboards/director-view' ||
          menu === 'meeting masters' ||
          nextPath.toLowerCase().indexOf(menu) >= 0
        );
      });
      if (canAccessDirectorView) {
        return true;
      }
    }

    _.forEach(resourcesValue, function (data) {
      let routematched = nextPath
        .toLowerCase()
        .indexOf(data.Menu.toLowerCase());

      if (routematched >= 0) {
        self.isRouteAllowed = true;
        return;
      }
    });
    if (this.isRouteAllowed) {
      // console.log('this.isRouteAllowed', this.isRouteAllowed);
      return true;
    } else {
      console.log('I would have routed back to structure; dashboards/director-view');
      this.router.navigate([
        'structure',
        { outlets: { 'structure-outlet': 'dashboards/director-view' } },
      ]);
      return false;
    }
  }
}
